export default __webpack_public_path__ + "static/media/018-hut.2d77abcc.svg";